/**
 * Video Controls — strips native controls from video and iframe elements.
 *
 * Auto-discovers all `.fit-video-wrapper[data-show-controls="false"]`
 * containers on the page and removes/hides playback controls from
 * `<video>` and `<iframe>` (YouTube, Vimeo) children.
 *
 * Extracted from blocks/video.liquid to allow caching and reuse.
 */
(function () {
  'use strict';

  function initVideoControls(root) {
    root.querySelectorAll('video').forEach(function (v) {
      v.removeAttribute('controls');
      try { v.controls = false; } catch (e) { /* readonly in some browsers */ }
      v.setAttribute('controlsList', 'nodownload noplaybackrate noremoteplayback');
    });

    root.querySelectorAll('iframe').forEach(function (f) {
      var src = f.getAttribute('src') || '';
      if (!src) return;

      function withParam(url, param) {
        return url + (url.indexOf('?') > -1 ? '&' : '?') + param;
      }

      if (src.indexOf('youtube.com') > -1 || src.indexOf('youtu.be') > -1) {
        if (src.indexOf('controls=0') === -1) {
          f.src = withParam(src, 'controls=0&modestbranding=1&rel=0&playsinline=1');
        }
      } else if (src.indexOf('vimeo.com') > -1) {
        if (src.indexOf('controls=0') === -1) {
          f.src = withParam(src, 'controls=0&transparent=0&pip=0');
        }
      }
    });
  }

  /* Auto-discover all video wrappers with controls disabled */
  try {
    var roots = document.querySelectorAll('.fit-video-wrapper[data-show-controls="false"]');
    for (var i = 0; i < roots.length; i++) {
      initVideoControls(roots[i]);
    }
  } catch (e) {
    /* Silently fail — non-critical enhancement */
  }
})();
